import { createAction } from 'Shared/utilities/actionCreator';

export enum FeatureToggle {
    FOOTER_FEATURE_VARIABLES = 'footerToggle/FOOTER_FEATURE_VARIABLES'
}

export type FeatureVariables = any;


const EmptyFeatureVariables = {};

export const updatefeatureVariables = (variables: FeatureVariables) =>
    createAction(FeatureToggle.FOOTER_FEATURE_VARIABLES, variables);

type FeatureAction = ReturnType<typeof updatefeatureVariables>

type FeatureState = {
    featureVariables: FeatureVariables
}

export const DEFAULT_STATE: FeatureState = {
    featureVariables: EmptyFeatureVariables
}

export default (state: FeatureState = DEFAULT_STATE, action: FeatureAction): FeatureState => {
    switch (action.type) {
        case FeatureToggle.FOOTER_FEATURE_VARIABLES:
            return {
                ...state,
                featureVariables: action.payload,
            };
        default:
            return state;
    }
}